import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import "react-table/react-table.css";
import axios from "axios";
import GenericReactTable from "../../../../../utils/genericComponents/GenericReactTable";
import GenericEchart from "../../../../../utils/genericComponents/GenericEchart";
import { useParams } from "react-router-dom";
import { TELEMETRY_API } from "../../../../../constants/serverConfig";
import Spinner from "../../../../../utils/Spinner";

const Utilization = (props) => {
  const [utilizationfreqdata, setUtilizationFrequencyData] = useState([]);
  const [utilizationUserdata, setUtilizationUserData] = useState([]);
  const [xaxisfrequencydata, setXaxisFrequencyData] = useState([]);
  const [yaxisuserdata, setXaxisUserData] = useState([]);
  const [xaxisLineardata, setXaxisLinearCountData] = useState([]);
  const [yaxisLinearuserdata, setYaxisLinearUserData] = useState([]);
  const [loading, setLoading] = useState(false);



  const params = useParams();

  const convertMilisecondtoYYYYMMDD = (miliseconds) => {
    var date = new Date(miliseconds);
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    return year + "-" + month + "-" + day;
  };

  const getUserCountByDate = () => {
    axios
      .get(
        `${TELEMETRY_API}util/users/count/historical/datasetId?datasetId=${params.id}`
      )
      .then((res) => {
        const sortedDecending = [...res.data].sort(
          (dayfirst, daysecond) => Number(daysecond.day) - Number(dayfirst.day)
        );
        let xaxisdata = [];
        let yaxisdata = [];

        if (sortedDecending?.length > 6) {
          sortedDecending.slice(0, 6).map(item => {
            item.count
              ? yaxisdata.push(item.count)
              : yaxisdata.push(null);
            item.day
              ? xaxisdata.push(
                convertMilisecondtoYYYYMMDD(item.day)
              )
              : xaxisdata.push("");
            return item;
          });
        } else {
          sortedDecending?.forEach(element => {
            element.count
              ? yaxisdata.push(element.count)
              : yaxisdata.push(null);
            element.day
              ? xaxisdata.push(
                convertMilisecondtoYYYYMMDD(element.day)
              )
              : xaxisdata.push("");
          });
        }
        let finaldata = sortedDecending.map((item, index) => {
          return {
            slno: index + 1,
            count: item.count,
            day: convertMilisecondtoYYYYMMDD(item.day),
          };
        });
        setXaxisFrequencyData(xaxisdata);
        setXaxisUserData(yaxisdata);
        setUtilizationFrequencyData(finaldata);
      });
  };
  const getUtilizationUsersByDataset = () => {
    setLoading(true);
    axios
      .get(
        `${TELEMETRY_API}util/users/datasets/datasetId?datasetId=${params.id}`
      )
      .then((res) => {
        let xaxislineardata = [];
        let yaxislineardata = [];
        let userByDataset = res.data;

        if (userByDataset?.length > 6) {
          userByDataset.slice(0, 6).map(item => {
            yaxislineardata.push(item.user);
            xaxislineardata.push(item.count)
            return item;
          });
        } else {
          userByDataset?.forEach(element => {
            yaxislineardata.push(element.user);
            xaxislineardata.push(element.count);
          });
        }

        let lineardata = [...res.data].map((item, index) => {
          return {
            slno: index + 1,
            user: item.user,
            count: item.count,
          };
        });
        setXaxisLinearCountData(xaxislineardata);
        setYaxisLinearUserData(yaxislineardata);
        setUtilizationUserData(lineardata);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    // if (props.tabStatus) {
    getUserCountByDate();
    getUtilizationUsersByDataset();
    // }
  }, [params.id, props.tabStatus]);

  const linegraphoption = {
    tooltip: {
      trigger: "item",
    },

    xAxis: [
      {
        type: "category",
        data: xaxisfrequencydata,
        name: "Date ",
        nameLocation: "middle",
        nameGap: 50,
      },
    ],
    title: {
      text: "",
      left: "",
      top: 0,
      textStyle: {
        color: "black",
      },
    },
    yAxis: [
      {
        type: "value",
        axisLabel: {
          formatter: "{value}",
        },
        name: "Count",
        nameLocation: "middle",
        nameGap: 50,
      },
    ],
    series: [
      {
        data: yaxisuserdata,
        type: "line",
        smooth: true,
      },
    ],
  };

  const bargraphoption = {
    grid: { containLabel: true },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    title: {
      left: "cener",
      text: "",
    },

    xAxis: {
      type: "value",
      name: "Count",
      nameLocation: "middle",
      nameGap: 50,
    },
    yAxis: {
      type: "category",
      data: yaxisLinearuserdata,
      name: "Users",
      nameLocation: "middle",
      nameGap: 300,
    },
    series: [
      {
        type: "bar",
        data: xaxisLineardata,
      },
    ],
  };
  const tableColumns = [
    {
      Header: () => <div className="column__table__header">Sl.no</div>,
      accessor: "slno",
      width: 150,
    },
    {
      Header: () => <div className="column__table__header">Day</div>,
      accessor: "day",
      width: 300,
    },
    {
      Header: () => <div className="column__table__header">Count</div>,
      accessor: "count",
      width: 80,
    },
  ];
  const userUtilizationColumns = [
    {
      Header: () => <div className="column__table__header">Sl.no</div>,
      accessor: "slno",
      width: 120,
    },
    {
      Header: () => <div className="column__table__header">User</div>,
      accessor: "user",
      width: 400,
    },
    {
      Header: () => <div className="column__table__header">Count</div>,
      accessor: "count",
      width: 80,
    },
  ];
  return (
    <div>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          <Row className="py-3">
            <Col>
              <div className="regular_border">
                <div className="utilization-usercount-heading">
                  User Count by Day
                </div>
                <GenericEchart options={linegraphoption} />

              </div>
            </Col>

            <Col className="d-flex">
              <GenericReactTable
                data={utilizationfreqdata}
                columns={tableColumns}
                tablewidth={650}
                tableheight="100%"
                sortable={true}
                pagination={true}
                pagesize={6}
                size="sm"
              />
            </Col>
          </Row>
          <Row className="py-3">
            <Col>
              <div className="regular_border">
                <div className="utilization-usercount-heading">
                  User Utilization by datasets
                </div>
                <GenericEchart options={bargraphoption} />
              </div>
            </Col>

            <Col className="d-flex">
              <GenericReactTable
                data={utilizationUserdata}
                columns={userUtilizationColumns}
                tablewidth={650}
                tableheight="100%"
                sortable={true}
                pagination={true}
                pagesize={6}
                size="sm"
              />
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default Utilization;
